import { RelatedTag } from '@empathy/search-types';
import { QuerySignalsState } from '../../../models';
import { QUERY_SIGNALS_MUTATIONS_KEYS } from '../query-signals.const';
import { QuerySignalsMutation } from '../query-signals.interfaces';

export type SetNextQueriesStatePayload = Pick<QuerySignalsState, 'nextQueries' | 'nextQueriesQuery'>;

export class SetQuerySignalsMutation implements QuerySignalsMutation {
  mutations = {
    [QUERY_SIGNALS_MUTATIONS_KEYS.setRelatedTags]: (querySignalsState: QuerySignalsState, relatedTags: RelatedTag[]) => {
      querySignalsState.relatedTags = relatedTags;
    },
    [QUERY_SIGNALS_MUTATIONS_KEYS.setNextQueriesState]:
      (querySignalsState: QuerySignalsState, { nextQueries, nextQueriesQuery }: SetNextQueriesStatePayload) => {
        querySignalsState.nextQueries = nextQueries;
        querySignalsState.nextQueriesQuery = nextQueriesQuery;
        querySignalsState.lastNextQueryLoaded = null;
      }
  };
}
